import { BaseEntryScope } from '#packages/apilib';
import { PublishManagerApiKey, EditorAPIKey } from '#packages/apis';
import { SeoAutoRedirectStore } from './store';

export class Scope extends BaseEntryScope {
  publishManagerApi = this.useDependency(PublishManagerApiKey);
  editorApi = this.useDependency(EditorAPIKey);
  store = this.declareStore(SeoAutoRedirectStore);
}
